// extracted by mini-css-extract-plugin
module.exports = {"columns":"DetailPanel_columns__pO3LF","col":"DetailPanel_col__spcAl","title":"DetailPanel_title__1EJRa","value":"DetailPanel_value__2egxD"};